import script from "./Citation.vue?vue&type=script&setup=true&lang=js"
export * from "./Citation.vue?vue&type=script&setup=true&lang=js"

import "./Citation.vue?vue&type=style&index=0&id=89ed1700&lang=scss"

const __exports__ = script;

export default __exports__